import Style from "./FJSelectedBackground.module.less";
import React, {memo} from "react";
import FJClickedIcon from "../../../icon/clicked.svg";
import InlineSVG from "react-inlinesvg";

function FJSelectedBackground(props) {
  let {top} = props;
  return (
    <div className={Style.svgAnimationBox} style={{top}}>
      <InlineSVG src={FJClickedIcon}/>
    </div>
  );
}

export default memo(FJSelectedBackground);